import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';
import type { ConfirmOptions } from '../contexts/ToastContext';

export function useNavigationGuard(
  isDirty: boolean,
  confirm: (opts: ConfirmOptions) => Promise<boolean>,
  skipRef?: React.RefObject<boolean>
) {
  const blocker = useBlocker(isDirty && !(skipRef?.current));
  const blockerRef = useRef(blocker);
  blockerRef.current = blocker;

  useEffect(() => {
    if (blocker.state !== 'blocked') return;

    confirm({
      title: 'Unsaved Changes',
      description: 'You have unsaved changes that will be lost if you leave this page.',
      confirmLabel: 'Leave',
      cancelLabel: 'Stay',
      destructive: true,
    }).then((leave) => {
      const current = blockerRef.current;
      if (current.state !== 'blocked') return;
      if (leave) {
        current.proceed?.();
      } else {
        current.reset?.();
      }
    });
  }, [blocker.state]); // eslint-disable-line react-hooks/exhaustive-deps
}
